import { gql } from '@apollo/client';

export const VIDEO_FRAGMENT = gql`
  fragment videoValues on Video {
    videoId: id
    fileName
    fileSize
    publicUrl
    createdTimestamp
    uploadStatus
  }
`;
